import React from 'react';
import { FormControl } from '@material-ui/core';
import { TextFieldBaseStyled } from 'components/forms/TextField/styles';
import { useInput } from 'components/forms/hooks/useInput';

type InputProps = {
    name: string;
    type?: string;
    isEditable?: boolean;
    clearError?: boolean;
    defaultValue?: number | string;
    onValueChange?: Function;
    disabled?: boolean;
    maxLength?: number;
    onInputBlur?: Function;
    placeholder?: string;
    style?: object;
    value?: number | string;
    className?: string;
    multiline?: boolean;
    rows?: number;
};

const TextField = ({
    name,
    type,
    isEditable,
    clearError,
    defaultValue,
    onValueChange,
    disabled,
    maxLength,
    onInputBlur,
    placeholder,
    style,
    value,
    className,
    multiline,
    rows,
}: InputProps): JSX.Element => {
    const isTypeNumber = type === 'number';
    const { meta, field, onChange, onBlur } = useInput({ name, defaultValue, clearError, isTypeNumber });
    const inputType = isTypeNumber ? 'text' : type;

    const handleChange = (e) => {
        if (maxLength !== undefined && e.target.value?.length > maxLength) {
            e.target.value = e.target.value.slice(0, maxLength);
        }
        if (typeof onValueChange === 'function') {
            onValueChange(e);
        }
        onChange(e);
    };

    const handleBlur = (e) => {
        if (typeof onInputBlur === 'function') {
            onInputBlur(e);
        }
        onBlur(e);
    };

    return isEditable ? (
        <FormControl error={Boolean(meta.error && meta.touched)} variant="outlined">
            <TextFieldBaseStyled
                {...field}
                type={inputType}
                onBlur={handleBlur}
                onChange={handleChange}
                disabled={disabled}
                placeholder={placeholder}
                style={style}
                className={className}
                multiline={multiline}
                {...(rows ? { rows } : {})}
                {...(value ? { value } : {})}
            />
        </FormControl>
    ) : (
        <span>{field.value}</span>
    );
};

TextField.defaultProps = {
    type: '',
    isEditable: false,
    clearError: false,
    defaultValue: null,
    onValueChange: undefined,
    disabled: false,
    maxLength: undefined,
    onInputBlur: undefined,
    placeholder: undefined,
    style: undefined,
    value: undefined,
    className: '',
    multiline: false,
    rows: undefined,
};

export default TextField;
